<template lang="pug">
#modal-visualizacao-laudo
    el-dialog(
        :title="$t('mensagens.operacao.listaFiscalizacao.titulo')",
        width='500px',
        :visible='show',
        @close='closeDialog()'
    )
      div.dialog-body
        .mapa
          Mapa(
              :mapLayersConfigs='layersMaps',
              :mapConfig='mapConfig',
              :height='"100%"',
              :idMapa='"mapaVizualizacaoLaudo"',
              locked
          )

      p
        b {{ $t('mensagens.operacao.operacao') }}:
        |
        | {{ informacoesLaudo.identificadorOperacao }}
      p
        b {{ $t('mensagens.operacao.listaFiscalizacao.beneficiario') }}:
        |
        | {{ informacoesLaudo.nomeBeneficiario }}
      p
        b {{ $t('mensagens.operacao.listaFiscalizacao.localidadeTerritorio') }}:
        |
        | {{ buscarLocalidades() }}
      div(v-if='informacoesLaudo.situacao === "Cancelado"')
        p
          b {{ $t('mensagens.operacao.listaFiscalizacao.situacao') }}:
          |
          |
          span(:class='["tag", "cancelado"]') {{ informacoesLaudo.situacao ? $t(`mensagens.operacao.${informacoesLaudo.situacao.toUpperCase()}`) : '--' }}
        p
          b {{ $t('mensagens.operacao.listaFiscalizacao.responsavelCancelamento') }}:
          |
          | {{ informacoesLaudo.nomeUsuarioCancelamento }}
        p
          b {{ $t('mensagens.operacao.listaFiscalizacao.motivo') }}:
          |
          | {{ informacoesLaudo.justificativaCancelamento }}
      BaseButton(slot='footer', size='mini', @click='closeDialog()') Voltar
</template>

<script>
import Mapa from '@/components/MapaLeaflet.vue';
import OperacaoLaudoService from '@/services/OperacaoLaudoService';
import { getEstiloGeometria } from '@/utils/mapa/mapa.estilos';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'ModalVisualizacaoLaudo',

    components: {
        Mapa,
        BaseButton
    },

    props: {
        idLaudo: {
            type: Number | null,
            required: true
        },
        show: {
            type: Boolean,
            required: true
        }
    },

    data() {
        return {
            informacoesLaudo: {
                identificadorOperacao: '',
                nomeBeneficiario: '',
                territorios: ''
            },
            layersMaps: [],
            mapConfig: {
                controls: {}
            }
        };
    },

    watch: {
        idLaudo: function () {
            this.getInformacoes();
        }
    },

    mounted() {
        this.getInformacoes();
    },

    methods: {
        mostrarTerritorioNoMapa() {
            this.layersMaps = [];

            let layerTerritorio;
            this.informacoesLaudo.territorios.forEach((territorio) => {
                layerTerritorio = {
                    style: getEstiloGeometria('area'),
                    name: 'Território Laudo',
                    geoJson: territorio.geometria
                };
                this.layersMaps.push(layerTerritorio);
            });
        },

        async getInformacoes() {
            if (!this.idLaudo) return null;

            await OperacaoLaudoService.buscarPorId(this.idLaudo)
                .then(({ data }) => {
                    this.informacoesLaudo = data;
                    setTimeout(() => this.mostrarTerritorioNoMapa(), 500);
                })
                .catch(() => {
                    this.$notify.error({
                        message:
                            this.$t('mensagens.operacao.notificacao.erroBuscaInformacaoFiscalizacao')
                    });
                });
        },

        buscarLocalidades() {
            let nomes = this.informacoesLaudo.territorios ? this.informacoesLaudo.territorios.map(function(territorio) {
                return territorio.localidade;
            }).join(', ') : null;

            return nomes;
        },

        closeDialog() {
            this.$emit('update:show', false);
        }
    }
};
</script>

<style lang="scss" scoped>
#modal-visualizacao-laudo {
  .el-dialog__footer {
      margin-top: -30px;
      display: flex;
      justify-content: flex-start;
  }

  .dialog-body {
    margin-top: 5%;
  }

  .mapa {
      height: 150px;
      border-radius: 4px;
      overflow: hidden;
      margin: -20px 0 20px 0;
  }

  .lista {
      margin-left: 15px;
  }

  .margin-p {
      margin-bottom: 0;
  }
  
  .margin-p-block {
      margin-top: 15px;
  }

  .cancelado {
    border: 1px solid var(--tag-danger-border);
    background-color: var(--tag-danger-background);
    color: var(--tag-danger-text);
  }

  .tag {
    border-radius: 5px;
    text-align: center;
    font-size: 11px;
    font-weight: 500;
    padding: 3px;
  }
}
</style>
